export default function PHP_filter_var() {
  return (
    <div>
      <h1>PHP_filter_var</h1>
    </div>
  );
}
